import { v4 as uuidv4 } from 'uuid';
import axios, { AxiosInstance, AxiosRequestConfig, InternalAxiosRequestConfig } from 'axios';
import { AxiosConfig } from 'src/services/service-manager';

export abstract class AxiosService {

  protected facilityCode: string | undefined;
  protected visitId: number | undefined;

  protected axiosInstance: AxiosInstance;

  constructor() {
    this.axiosInstance = axios.create();
    this.axiosInstance.interceptors.request.use(
      (config: InternalAxiosRequestConfig) => {
        config.headers['x-request-id'] = uuidv4();
        // config.headers['cookie'] = 'JSESSIONID=CD613FBE2CBED605EB8E570E79B3E2F6;';
        return config;
      }
    );
  }

  setAxiosConfig(config: AxiosConfig) {
    this.setBaseUrl(config.baseUrl);
    this.facilityCode = config.facilityCode;
    this.visitId = config.visitId;
  }

  protected setBaseUrl(url: string) {
    this.axiosInstance.defaults.baseURL = url;
  }

  protected async axiosCall<T>(config: AxiosRequestConfig): Promise<{err?: Error|unknown, data?: T}> {
    try {
      const {data} = await this.axiosInstance.request<T>(config);
      return { data };
    } catch (err: unknown) {
      return {err};
    }
  }
}
